module.exports = __webpack_public_path__ + "static/media/landelijk.760529a9.jpg";